import DemoErrorBoundary from './DemoErrorBoundary';

export default DemoErrorBoundary;
